import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import * as Sentry from '@sentry/react'; // Import Sentry
import React from 'react';
import QRCode from 'react-qr-code';

import { qrbackground, qrcode, qrwrapper } from './QrComponent.scss';

interface Props {
  qrCodeData?: string;
}

const QrComponent = ({ qrCodeData }: Props) => {
  const isSwcPixSentryCaptureMessageEnabled = useFeature(
    FeatureFlag.SwcPixSentryCaptureMessageEnabled
  );

  if (qrCodeData) {
    if (isSwcPixSentryCaptureMessageEnabled) {
      const maskedQrCodeData = `${qrCodeData.substring(0, 10)}****${qrCodeData.substring(
        qrCodeData.length - 10
      )}`;

      Sentry.captureMessage(`Generated QR URL`, {
        level: 'info',
        tags: {
          paySystem: 'PIX'
        },
        extra: { maskedQrCodeData }
      });
    }

    return (
      <div className={qrwrapper}>
        <div className={qrbackground}>
          <QRCode size={180} className={qrcode} value={qrCodeData} viewBox="0 0 180 180" />
        </div>
      </div>
    );
  }
  return null;
};

export default QrComponent;
